<template>
  <div class="page-container">
    <div class="main">
      <div style="display:flex;align-items: center;">
        <h2 class="title" style="margin-right:20px">{{$t('payBills.payBills20')}}</h2>
        <div>{{$t('payBills.payBills7')}}</div>
      </div>
      <div class="title">{{$t('payBills.payBills8')}}</div>
      <div class="check">
        <el-checkbox-group v-model="checkArr">
          <el-checkbox v-for="item in checkList" :key="item.value" :label="item.value">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="title must">{{$t('payBills.payBills9')}}</div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="remindingEmail">
            <el-input style="width:500px" v-model="ruleForm.remindingEmail"></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <div>
              <h2 class="title">{{$t('switchs.switchs1')}}</h2>
              <span>
                <el-switch v-model="ruleForm.remindingFlag" class="switchClass" active-value="1" inactive-value="0"
                  :value="ruleForm.remindingFlag" :active-text="$t('switchs.switchs2')" :inactive-text="$t('switchs.switchs3')" />
                <span class="switch-text"
                  :style="{[ruleForm.remindingFlag?'left':'right']:'26px',color:ruleForm.remindingFlag?'#ff9000':'#1D2129'}"></span>
              </span>
              <span class="title-right">{{$t('switchs.switchs4')}}</span>
            </div>
          </el-form-item>
          <el-button type="primary" @click="handleSave">{{$t('baoc')}}</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
export default {
  data () {
    return {
      value: '',
      ruleForm: {
        remindingFlag: '0'
      },
      rules: {
        remindingEmail: [
          { required: true, message: this.$t('loginR.login9'), trigger: 'blur' },
          { type: 'email', message: this.$t('loginR.login20'), trigger: ['blur', 'change'] }
        ],
      },
      checkArr: [],
      checkList: [
        {
          name: this.$t('payBills.payBills10'),
          value: '1'
        },
        {
          name: this.$t('payBills.payBills11'),
          value: '2'
        },
        {
          name: this.$t('payBills.payBills12'),
          value: '3'
        },
        {
          name: this.$t('payBills.payBills13'),
          value: '4'
        },
        {
          name: this.$t('payBills.payBills14'),
          value: '5'
        },
        {
          name: this.$t('payBills.payBills15'),
          value: '6'
        },
        {
          name: this.$t('payBills.payBills16'),
          value: '7'
        },
        {
          name: this.$t('payBills.payBills17'),
          value: '8'
        },
        {
          name: this.$t('payBills.payBills18'),
          value: '9'
        },
        {
          name: this.$t('payBills.payBills19'),
          value: '10'
        },
        {
          name: this.$t('payBills.payBills21'),
          value: '11'
        },
      ],
    };
  },
  methods: {
    handleSave () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let data = {}
          data = this.ruleForm
          data.remindingNode = this.checkArr.join(',')
          this.$http.post('email/reminding/save', data).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('操作成功')
            }
          })
        }
      })
    },
    getInfo () {
      this.$http.get('email/reminding/query').then((res) => {
        if (res.data.data.remindingNode) {
          this.checkArr = res.data.data.remindingNode.split(',')
        }
        // 消息开关回显
        if (res.data.data.remindingFlag) {
          this.ruleForm.remindingFlag = Number(res.data.data.remindingFlag)
        }
        this.ruleForm = res.data.data
      })
    }
  },
  created () {
    this.getInfo()
  },
};
</script>
<style lang='scss' scoped>
.title {
  font-size: 20px;
  margin: 30px 0;
}
.main {
  width: 1100px;
  margin: 0 auto;
  margin-top: 20px;
}
.must::before {
  content: "*";
  color: red;
}

.title-right {
  margin-left: 30px;
}
</style>

<style>
/* switch按钮样式 */
.switchClass .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}
/*打开时文字位置设置*/
.switchClass .el-switch__label--right {
  z-index: 1;
}
/* 调整打开时文字的显示位子 */
.switchClass .el-switch__label--right span {
  margin-right: 13px;
  margin-left: 13px;
  font-size: 12px;
}
/*关闭时文字位置设置*/
.switchClass .el-switch__label--left {
  z-index: 1;
}
/* 调整关闭时文字的显示位子 */
.switchClass .el-switch__label--left span {
  margin-left: 25px;
  font-size: 12px;
}
/*显示文字*/
.switchClass .el-switch__label.is-active {
  display: block;
}
/* 调整按钮的宽度 */
.switchClass.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 66px !important;
  margin: 0;
}
.check .el-checkbox {
  margin-bottom: 15px;
}
</style>